const $searchResults = $('.search-results__return');
const platform = require('platform');

if (!(platform.name == 'IE' && parseInt(platform.version) < 11)) {
	$('.js-search-filter')
		.outerWidth('100%')
		.select2({
			theme: 'news-filter',
			minimumResultsForSearch: Infinity
		});
}

$('.js-search-filter')
	.on('change', function () {
	$(this).closest('form').trigger('submit');
	/*	if ($(this).hasClass('js-search-filter--sort')) {
			location.href = $(this).val();
		} else {
			$.get($(this).val(), function (data) {
				let subData = data.substring(data.indexOf('class="search-results__return"') + 31, data.length);
				$searchResults
					.find('.u-preloader')
					.remove();
				$searchResults
					.addClass('search-data')
					.html(subData);
			});
		}
	*/
	});



// WEBPACK FOOTER //
// ./frontend/components/search/search.js